export const SET_END_DATE_RANGE_FILTER = "SET_END_DATE_RANGE_FILTER";
export const SET_START_DATE_RANGE_FILTER = "SET_START_DATE_RANGE_FILTER";
export const SET_DATE_RANGE_ERROR = "SET_DATE_RANGE_ERROR";
export const CLEAR_DATE_RANGE_ERROR = "CLEAR_DATE_RANGE_ERROR";
